import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=529d6f2c&"
import script from "./TeamModal.vue?vue&type=script&lang=ts&"
export * from "./TeamModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports